import { combineReducers } from '@reduxjs/toolkit';

import { formDetailsSlice } from './formDetails';

export const processFormsReducers = combineReducers({
  formDetails: formDetailsSlice.reducer,
});
